import * as types from "../../actionTypes";
import { toast } from "../../../UIComponents/Toast";
import { client } from "../../../utils/axios";

export const getSingleMedicine = (payload) => ({
  type: types.GET_SINGLE_MEDICINE_dETAILS,
  payload,
});

export const getMedicineListLoading = () => ({
  type: types.GET_MEDICINE_LIST_LOADING,
});

export const getMedicineListSuccess = (data) => ({
  type: types.GET_MEDICINE_LIST_SUCCESS,
  payload: data,
});

export const getMedicineListError = (error) => ({
  type: types.GET_MEDICINE_LIST_ERROR,
  payload: error,
});

export const loadMedicineList = () => {
  return function (dispatch) {
    dispatch(getMedicineListLoading());
    client
      .post(
        `/doctor/get-medicine-list-value`
        // null
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(getMedicineListSuccess(resp.data));
        toast.success("Medicines fetched successfully");
      })
      .catch((error) => {
        dispatch(getMedicineListError(error.response));
      });
  };
};
